export default __webpack_public_path__ + "images/14b8feae7df071bc7d529c2de875bc13-seasonal_module_spd_festive_fun_mobile.webp";